import { render, staticRenderFns } from "./PaymentLinkLayout.vue?vue&type=template&id=2ecb8dbc&scoped=true"
import script from "./PaymentLinkLayout.vue?vue&type=script&lang=js"
export * from "./PaymentLinkLayout.vue?vue&type=script&lang=js"
import style0 from "./PaymentLinkLayout.vue?vue&type=style&index=0&id=2ecb8dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecb8dbc",
  null
  
)

export default component.exports